import React, {useEffect, useState} from "react";
import {message, Button, Drawer, Form} from "antd";
import {advertisingModel} from "../../../../../entities/advertising";
import {ApiAdvertisingService} from "../../../../../shared/api";
import {config} from "../../../../../shared/config/config";
import {AdvertisingTable} from "./Table/Table";
import {AdvertisingForm} from "./Form/Form";


export const AdvertisingSection = () => {
  const [form] = Form.useForm();
  const [advertiseList, setAdvertiseList] = useState([])
  const [advertisingFile, setAdvertisingFile] = useState([])
  const [isOpenedDrawer, setIsOpenedDrawer] = useState(false)
  const [editableSlideId, setEditableSlideId] = useState(null)

  useEffect(() => {
    fetchSlides()
  }, [])

  useEffect(() => {
    if (!isOpenedDrawer) {
      setAdvertisingFile([])
      setEditableSlideId(null)
      form.resetFields()
    }
    // eslint-disable-next-line
  },[isOpenedDrawer])

  const fetchSlides = async() => {
    try {
      const {data} = await ApiAdvertisingService.fetch()
      setAdvertiseList(data)
    } catch (e) {
      console.log(e)
    }
  }

  const setEditableSlide = (id) => {
    const editableSlide = advertiseList.find(slide => slide.id === id)
    form.setFieldsValue(editableSlide)
    if (editableSlide.fileName) {
      setAdvertisingFile([{
        name: editableSlide.fileName,
        url: `${config.API_HOST}/media/${editableSlide.fileName}`,
      }])
    }
  }

  const createAdvertisingSlide = async (values) => {
    const curatorWithoutImage = !advertisingFile.length
    if (curatorWithoutImage) {
      return message.error('Прикрепите фотографию к карточке куратора')
    }
    console.log(form.getFieldValue('id'))
    const slideWithSamePriority = advertiseList.find(item => item.priority === Number(form.getFieldValue('priority')))
    if (slideWithSamePriority) {
      if (!(editableSlideId && editableSlideId === slideWithSamePriority.id)) {
        return message.error('Такой номер слайда уже существует')
      }
    }
    const formData = new FormData();
    Object.entries(values).forEach(item => {
      const [key, value] = item
      return formData.append(key, value ? value : '');
    })

    advertisingFile[0]?.originFileObj
      ? formData.append('file', advertisingFile[0].originFileObj)
      : formData.append('file', '')

    try {
      editableSlideId
        ? await advertisingModel.update(editableSlideId, formData)
        : await advertisingModel.create(formData)

      message.success(`Рекламный слайд успешно ${editableSlideId ? 'изменен' : 'создан'}`)
      setTimeout(() => setIsOpenedDrawer(false), 500)
      fetchSlides()
    } catch (e) {
      message.error('Упс, произошла ошибка')
      setTimeout(() => setIsOpenedDrawer(false), 500)
    }
  }
  return (
    <>
      <AdvertisingTable
        advertiseList={advertiseList}
        fetchSlides={fetchSlides}
        setIsOpenedDrawer={setIsOpenedDrawer}
        setEditableSlide={setEditableSlide}
        setEditableSlideId={setEditableSlideId}
      />

      <Drawer
        title={`${editableSlideId ? 'Изменить' : 'Создать'} рекламный слайд`}
        width={720}
        onClose={() => setIsOpenedDrawer(false)}
        visible={isOpenedDrawer}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setIsOpenedDrawer(false)} style={{marginRight: 8}}>
              Отменить
            </Button>
            <Button type="primary" htmlType="submit" form="createCurator" >
              {editableSlideId ? 'Изменить' : 'Создать'}
            </Button>
          </div>
        }
      >
       <AdvertisingForm
        form={form}
        createAdvertisingSlide={createAdvertisingSlide}
        advertisingFile={advertisingFile}
        setAdvertisingFile={setAdvertisingFile}
       />
      </Drawer>
    </>
  )
}
